const MODULE = "Cruise";

const ACTIONS = {
  PAGE_ASSIGNED: "Page Assigned to Cruise",
  PAGE_DUPLICATED: "Page Duplicated to Cruise", 
  PAGE_REMOVED: "Page Removed from Cruise",
  CRUISE_PAGE_CREATED: "Cruise Page Created",
  CRUISE_PAGE_UPDATED: "Cruise Page Updated"
};

export const CRUISE_PAGE_LOG_TYPES = {
  MODULE,
  ACTIONS
};